import React, { useEffect, useState } from "react";
import { ApiPaths } from "../../Config/ApiPath";
import Loader from "../../Components/Loader/Loader";
import useAxiosHelper from "../../Common/AxiosHelper";
import { toastSuccess, toastFailed } from "../../Common/Data";
import moment from "moment";

const UplineBonus = () => {
  const [loading, setLoading] = useState(false);
  const [rewardData, setRewardData] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const { AxiosGet, AxiosPost } = useAxiosHelper();

  useEffect(() => {
    FetchData();
  }, []);

  const FetchData = async () => {
    try {
      setLoading(true);
      const tempRank = await AxiosGet(ApiPaths.getUplineBonus);
      setRewardData(tempRank);
    } catch (error) {
      console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange = (rankId, value) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [rankId]: value,
    }));
  };

  const handleClaimReward = async (rankId) => {
    const selectedValue = selectedValues[rankId];
    try {
      if (!selectedValue || selectedValue === "Select") {
        toastFailed("No option selected.");
        return;
      }
      console.log("selectedValue?.rankId", selectedValue);
      const body = {
        item: selectedValue,
        rankId: rankId,
      };
      const response = await AxiosPost(ApiPaths.claimReward, body);
      toastSuccess("Reward claimed successfully");
      FetchData();
      console.log("Reward claimed:", response);
    } catch (error) {
      toastFailed("Error claiming reward");
      console.error("Error claiming reward:", error);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="dashboard">
        <section className="history">
          <h1 className="textHeading">Upline Bonus</h1>
          <div className="table">
            <table>
              <thead>
                {rewardData &&
                  Array.isArray(rewardData) &&
                  rewardData.length > 0 && (
                    <tr>
                      <th>S.No</th>
                      <th>Upline Level</th>
                      <th>Income</th>
                      <th>Level</th>
                      <th>Total Directs / Req Directs</th>
                      <th>Direct Business / Req Business</th>
                      {/* <th>Leadership Income</th>
                       <th>Monthly Salary Income</th> */}
                      <th>Status</th>
                      <th>Achieved Date</th>
                    </tr>
                  )}
              </thead>
              <tbody>
                {rewardData &&
                Array.isArray(rewardData) &&
                rewardData.length > 0 ? (
                  rewardData.map((x, i) => (
                    <tr
                      key={x?.rankId}
                      style={{
                        background: x?.status == "1" && "green !important",
                      }}
                    >
                      <td>{i + 1}</td>
                      <td>{x?.upline_level}</td>
                      <td>{x?.income}%</td>
                      <td>{x?.level}</td>
                      <td>
                        {x?.direct_members} {" / "} {x?.direct_required}
                      </td>
                      <td>
                        {x?.direct_business} {" / "}
                        {x?.direct_business_required}
                      </td>
                      {/* <td>{x?.leadership_income?.amount}%</td>
                       <td>{x?.monthly_income?.amount}</td> */}

                      {x?.status == "1" ? (
                        <td style={{ color: "var(--colorSuccess)" }}>
                          Achieved
                        </td>
                      ) : (
                        <td>Pending</td>
                      )}

                      <td>
                        {x?.uplineAchievedDate && x?.uplineAchievedDate != "-"
                          ? moment(x?.uplineAchievedDate).format("lll")
                          : "----"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">No history yet</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </section>
    </>
  );
};

export default UplineBonus;
